export default function debounce(func, delay) {
  var timer;
  return function () {
    var _this2 = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      func.apply(_this2, args);
    }, delay);
  };
}
export function Debounce(func, delay) {
  return function (args) {
    var _this = this;
    var _args = args;
    clearTimeout(func.id);
    func.id = setTimeout(function () {
      func.call(_this, _args);
    }, delay);
  };
}